import { useSelector } from 'react-redux';
import { selectMainTheme } from 'app/store/fuse/settingsSlice';
import { ThemeProvider } from '@material-ui/core/styles';
import { Dialog, DialogContent, LinearProgress, Typography } from '@material-ui/core';

function LoadingDialog(props) {
	const mainTheme = useSelector(selectMainTheme);

	return (
		<ThemeProvider theme={mainTheme}>
			<Dialog open fullWidth>
				<DialogContent className="p-20">
					<div className="flex flex-1 flex-col items-center justify-center p-24">
						<Typography className="text-13 sm:text-20 mb-16" color="textSecondary">
							{props.content || 'Betöltés...'}
						</Typography>
						<LinearProgress className="w-192 sm:w-320 max-w-full rounded-2" color="secondary" />
					</div>
				</DialogContent>
			</Dialog>
		</ThemeProvider>
	);
}

export default LoadingDialog;
